module.exports = __webpack_public_path__ + "static/media/Lamborghini.3813e06f.jpeg";